import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/logo/mainMenuOebbLogo.png'
import _imports_1 from '../../assets/images/logo/cdes_logo_R2.png'
import _imports_2 from '../../assets/images/logo/mainMenuCdesLogo.png'


const _hoisted_1 = { class: "d-flex flex-column w-100" }
const _hoisted_2 = {
  key: 0,
  class: "mainMenuOebbLogoSize",
  src: _imports_0
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://cdes.at",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mainMenuCdesLogoSizeM",
    src: _imports_1,
    title: "concurrent design"
  })
], -1)
const _hoisted_4 = { class: "d-flex flex-column flex-grow-1 justify-content-end mainMenuTopRow" }
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  class: "",
  role: "presentation"
}
const _hoisted_7 = ["id", "data-bs-target", "aria-controls", "aria-selected", "onClick"]
const _hoisted_8 = { class: "d-flex flex-row mainMenuOebbLogoSize justify-content-end" }
const _hoisted_9 = { class: "d-flex flex-column justify-content-end" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-row justify-content-end"
}
const _hoisted_11 = { class: "mainMenuCostumerLabel" }
const _hoisted_12 = {
  key: 1,
  class: "d-flex flex-row justify-content-end"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://cdes.at",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mainMenuCdesLogoSize",
    src: _imports_2
  })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "bi bi-stack fs-5 position-relative" }
const _hoisted_18 = { class: "fs-6" }
const _hoisted_19 = {
  key: 0,
  class: "position-absolute top-0 start-100 badge rounded-pill bg-primary infoMessagesBadge"
}
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "bi bi-info-square-fill fs-5 position-relative" }
const _hoisted_23 = { class: "fs-6" }
const _hoisted_24 = {
  key: 0,
  class: "position-absolute top-0 start-100 badge rounded-pill bg-primary infoMessagesBadge"
}
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = ["id", "title"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "bi-list topMenuIcon" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  class: "dropdown-menu pe-3",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_30 = { class: "dropdown-header topMenuUserCaption" }
const _hoisted_31 = { class: "topMenuUserSubSection" }
const _hoisted_32 = { class: "topMenuUserItem" }
const _hoisted_33 = { class: "topMenuUserText" }
const _hoisted_34 = { class: "dropdown-header topMenuUserCaption" }
const _hoisted_35 = { class: "topMenuUserSubSection" }
const _hoisted_36 = { class: "topMenuUserItem" }
const _hoisted_37 = { class: "topMenuUserText" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "bi-person topMenuItemIcon" }, null, -1)
const _hoisted_39 = { class: "topMenuItemText" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "btn btn-sm cic-svg person-gear me-2" }, null, -1)
const _hoisted_41 = { class: "topMenuItemText" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "btn btn-sm cic-svg ueber me-1 sm" }, null, -1)
const _hoisted_43 = { class: "topMenuItemText" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "bi-box-arrow-right topMenuItemIcon" }, null, -1)
const _hoisted_45 = { class: "topMenuItemText" }
const _hoisted_46 = { class: "d-flex flex-column mainMenuDetailRow align-items-center mainMenuSectionBottom" }
const _hoisted_47 = ["id"]
const _hoisted_48 = ["id", "aria-labelledby"]
const _hoisted_49 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_50 = { class: "d-flex flex-row" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  class: "flex-grow-1",
  role: "none"
}
const _hoisted_53 = {
  key: 0,
  class: "subItemSectionText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('d-flex flex-row ' + (!this.ctx.isTestInstance() ? (this.ctx.enableCustomerLogo() ? 'mainMenuOebbColor' : 'mainMenuCdesColor') : ' mainMenuTestingInstanceColor'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(this.ctx.enableCustomerLogo() ? '' : 'mainMenuCdesLogoDiv')
      }, [
        (this.ctx.enableCustomerLogo())
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
        _hoisted_3
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", {
          class: "d-flex flex-row justify-content-center nav nav-pills",
          id: _ctx.$id('pills-tab'),
          role: "tablist"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuEntries, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (this.mayShow(item))
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createElementVNode("button", {
                      class: _normalizeClass(this.ctx.enableCustomerLogo() ? 'mainMenuOebbSectionButton' : 'mainMenuCdesSectionButton' + (this.isActiveMainMenuSection(item.id) ? ' activeEntry' : '')),
                      id: _ctx.$id(item.id) + "-tab",
                      "data-bs-toggle": "tab",
                      "data-bs-target": "#" + _ctx.$id(item.id),
                      type: "button",
                      role: "tab",
                      "aria-controls": item.id,
                      "aria-selected": item.id === 'plan',
                      onClick: ($event: any) => (this.activateMainMenuButton(item.id))
                    }, _toDisplayString(_ctx.$t(item.labelKey)), 11, _hoisted_7)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (!this.ctx.enableCustomerLogo())
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(this.ctx.costumerLabel), 1)
              ]))
            : _createCommentVNode("", true),
          (this.ctx.enableCustomerLogo())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn text-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openJobList'))),
          title: _ctx.$t('mainMenu.topMenuJobCaption')
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                (_ctx.numberOfJobs > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$n(_ctx.numberOfJobs)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 8, _hoisted_15),
        _createElementVNode("button", {
          type: "button",
          class: "btn text-white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openInfoMessages'))),
          title: _ctx.$t('mainMenu.topMenuInfoCaption')
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, [
                (_ctx.infoMessages.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$n(_ctx.infoMessages.length)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 8, _hoisted_20),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "d-flex flex-column justify-content-center btn text-white topMenuButton",
            type: "button",
            id: _ctx.$id('topMenuButton'),
            title: _ctx.$t('mainMenu.topMenuUserCaption'),
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, _hoisted_28, 8, _hoisted_26),
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", null, [
              _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t("mainMenu.topMenuLoggedInCaption")), 1),
              _createElementVNode("ul", _hoisted_31, [
                _createElementVNode("li", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(this.ctx.person.givenName) + " " + _toDisplayString(this.ctx.person.surName), 1)
                ])
              ]),
              _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t("general.organisation")), 1),
              _createElementVNode("ul", _hoisted_35, [
                _createElementVNode("li", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(this.ctx.getActiveOPOrganisationName()), 1)
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAccessEdit && _ctx.openAccessEdit(...args))),
                class: "d-flex flex-row align-items-center dropdown-item"
              }, [
                _hoisted_38,
                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("mainMenu.topMenuAccessCaption")), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPersonalDataEdit && _ctx.openPersonalDataEdit(...args))),
                class: "d-flex flex-row align-items-center dropdown-item"
              }, [
                _hoisted_40,
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("mainMenu.topMenuPersonalDataCaption")), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('openAbout'))),
                class: "d-flex flex-row align-items-center dropdown-item"
              }, [
                _hoisted_42,
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("mainMenu.aboutCaption")), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                class: "d-flex flex-row align-items-center dropdown-item"
              }, [
                _hoisted_44,
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("mainMenu.topMenuLogoutCaption")), 1)
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", {
        class: "tab-content",
        id: _ctx.$id('pills-tabContent')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuEntries, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["tab-pane fade", { 'show active': item.id === 'plan' }]),
            id: _ctx.$id(item.id),
            role: "tabpanel",
            "aria-labelledby": _ctx.$id(item.id) + "-tab"
          }, [
            _createElementVNode("div", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subMenu, (subItemSection) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: subItemSection.id
                }, [
                  (this.mayShowSubItem(subItemSection))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass('d-flex flex-column px-3 align-items-center' + (subItemSection.pos != item.subMenu.length + (this.ctx.mayBuek ? 0 : (subItemSection.noBuekOffset ?? 0)) ? ' mainMenuSectionRight' : ''))
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItemSection.entries, (subMenuEntry) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: subMenuEntry.id
                            }, [
                              ((!subMenuEntry.onlySuperAdmin || this.ctx.isSuperAdmin) && (!subMenuEntry.onlyShowPerson || this.ctx.hasShowPerson) && (!subMenuEntry.onlyEditPerson || this.ctx.hasEditPerson) && (!subMenuEntry.onlyEditProject || this.ctx.hasEditProject)
                                       && (!subMenuEntry.onlyGenerateReviewReport || this.ctx.hasGenerateReviewReport) && (!subMenuEntry.certificateAdministrationGlobal || !this.ctx.certificateAdministrationGlobal) )
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: { path : subMenuEntry.target },
                                    class: "mainMenuRouterLink p-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        class: "col p-1 mainMenuButton d-flex flex-column align-items-center",
                                        onClick: ($event: any) => (this.menuButtonClicked(subMenuEntry))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass('cic-svg ' + subMenuEntry.icon)
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t(subMenuEntry.labelKey)), 1)
                                      ], 8, _hoisted_51)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        (subItemSection.labelKey != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.$t(subItemSection.labelKey)), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ], 10, _hoisted_48))
        }), 128))
      ], 8, _hoisted_47)
    ])
  ]))
}